import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule,
} from 'vuex-module-decorators';
import store from '@/store';
import * as api from '@/store/api';

// Definiera typer för JSON-strukturen
export interface BaseItem {
  id: string;
  name: string;
  description: string;
  price: number;
  category: string;
}

// Definiera olika typer av items
export interface ServiceItem extends BaseItem {
  type: 'service';
  duration?: string;
  includedServices?: string[];
}

export interface TaxItem extends BaseItem {
  type: 'tax';
  rate?: number;
  applicableTo?: string[];
}

// Lägg till fler typer här vid behov
// export interface NewTypeItem extends BaseItem {
//   type: 'newType';
//   specificField?: string;
// }

// Union type för alla möjliga item-typer
export type DataItem = ServiceItem | TaxItem; // | NewTypeItem

// Definiera typer för sidstrukturen
export interface ChoiceOption {
  id: string;
  dataName: string;
  title: string;
  imageUrl: string;
  nextPageId: string;
}

export interface ChoicePage {
  type: 'choice';
  id: string;
  title: string;
  description?: string;
  options: ChoiceOption[];
}

export interface StandardInfoSection {
  type: 'standard';
  title: string;
  content: string;
  icon?: string;
}

export interface CustomInfoSection {
  type: 'custom';
  html: string;
}

export type InfoSection = StandardInfoSection | CustomInfoSection;

export interface InfoPage {
  type: 'info';
  id: string;
  title: string;
  description?: string;
  sections: InfoSection[];
  nextPageId?: string;
}

export type Page = ChoicePage | InfoPage;

// Definiera typer för content-element
export interface ContentElement {
  type: string;
  value: string;
}

// Uppdaterad kategori-struktur för att stödja både items och categories
export interface Category {
  id: string;
  name: string;
  image: string;
  categories?: Category[]; // Rekursiv struktur för kategorier
  items?: Category[]; // Alternativ struktur för items
  content?: ContentElement[]; // Content för kategorier utan underkategorier
}

export interface DataCollection {
  type: string;
  name: string;
  categories: Category[]; // Använder den nya Category-typen
}

// Definiera alla möjliga datatyper
export type DataType = 'tax'; // | 'newType'

// Interface för att hantera alla datakollektioner
export interface DataCollections {
  [key: string]: DataCollection;
}

import { taxLegacyData } from '@/data/gt-library/legacy/taxLegacyData';

const defaultTaxData = taxLegacyData;

// Samla alla standarddata i ett objekt
const defaultData: DataCollections = {
  tax: defaultTaxData,
  // Lägg till fler datatyper här vid behov
  // newType: defaultNewTypeData,
};

@Module({
  namespaced: true,
  name: 'gt_services',
  store,
  dynamic: true,
})
class GtServicesModule extends VuexModule {
  // State
  dataCollections: DataCollections = defaultData;
  isLoading: boolean = false;
  error: string | null = null;

  // Getters
  get getDataByType() {
    return (type: DataType) => this.dataCollections[type];
  }

  get getIsLoading() {
    return this.isLoading;
  }

  get getError() {
    return this.error;
  }

  // Mutations
  @Mutation
  setDataCollection(type: DataType, data: DataCollection) {
    this.dataCollections = {
      ...this.dataCollections,
      [type]: data,
    };
  }

  @Mutation
  setIsLoading(isLoading: boolean) {
    this.isLoading = isLoading;
  }

  @Mutation
  setError(error: string | null) {
    this.error = error;
  }

  // FICK FELMEDDELANDE KRING DESSA ACTIONS OCH VALDE ATT INTE ANVÄNDA DETTA
  // Actions
  // @Action
  // async fetchData(type: DataType) {
  //   try {
  //     this.setIsLoading(true);
  //     this.setError(null);
  //     // Här kan du lägga till API-anrop för att hämta data
  //     // const response = await api.getData(type);
  //     // this.setDataCollection(type, response);
  //   } catch (error: any) {
  //     this.setError(error?.message || 'Ett okänt fel uppstod' );
  //   } finally {
  //     this.setIsLoading(false);
  //   }
  // }

  // @Action
  // async updateData(type: DataType, newData: DataCollection) {
  //   try {
  //     this.setIsLoading(true);
  //     this.setError(null);
  //     // Här kan du lägga till API-anrop för att uppdatera data
  //     // await api.updateData(type, newData);
  //     this.setDataCollection(type, newData);
  //   } catch (error: any) {
  //     this.setError(error?.message || 'Ett okänt fel uppstod');
  //   } finally {
  //     this.setIsLoading(false);
  //   }
  // }
}

export default getModule(GtServicesModule);
